import React from "react"

const LeadGen = props => {
  // Placeholder Lead Generation Component So That It Can Be Overridden For AnnSacks Lead Generation Page.
  return <></>
}

export default LeadGen
